import axiosWrapper from "./wrapper";

export function ccpPayCreate({netId, applicationId}) {
  const response = axiosWrapper(
    "post",
    `/api/ccp/payment/url/get`,
    {
      applicationId: applicationId,
    }
  );
  return response;
}